import { CSSProperties } from 'react'

const styles: Record<string, CSSProperties> = {
  kpiGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '16px',
    marginBottom: '16px'
  },
  kpiCard: {
    background: '#fff',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e8e8e8',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center'
  },
  kpiIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    flexShrink: 0
  },
  kpiContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  kpiLabel: {
    color: '#666',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 500
  },
  kpiValue: {
    fontSize: '28px',
    fontWeight: 600,
    lineHeight: 1
  },
  kpiSublabel: {
    color: '#999',
    fontSize: '10px'
  },
  kpiSubvalue: {
    color: '#666',
    fontSize: '10px',
    fontWeight: 500
  },
  /* Quick Actions */
  quickActionsScroll: {
    display: 'flex',
    overflowX: 'auto',
    overflowY: 'hidden',
    gap: '12px',
    paddingTop: '4px',
    paddingBottom: '80px',
    scrollBehavior: 'smooth'
  },
  quickActionCard: {
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    height: '100%',
    borderRadius: '8px',
    padding: '20px',
    border: '1px solid #e8e8e8',
    background: '#fff',
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '140px',
    minWidth: '160px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    flexShrink: 0
  },
  quickActionLabel: {
    color: '#1a1a1a',
    fontSize: '14px',
    textAlign: 'center'
  },
  quickActionDesc: {
    color: '#666',
    textAlign: 'center',
    fontSize: '12px'
  }
}

/** Hover effects applied via onMouseEnter / onMouseLeave */
export const hoverEffects = {
  kpiCardHover: {
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    transform: 'translateY(-4px)'
  } as CSSProperties,
  kpiCardDefault: {
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    transform: 'translateY(0)'
  } as CSSProperties,
  quickActionHover: {
    boxShadow: '0 8px 20px rgba(0, 87, 149, 0.15)',
    transform: 'translateY(-6px)',
    borderColor: 'var(--spectrum-accent-background-color-default, #005795)'
  } as CSSProperties,
  quickActionDefault: {
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    transform: 'translateY(0)',
    borderColor: '#e8e8e8'
  } as CSSProperties
}

export default styles
